var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{staticClass:"editStatrgyManagerDialog",attrs:{"dialog-show":_vm.dialogShow,"dialog-title":_vm.title},on:{"close":_vm.beforeClose,"submit":_vm.confirm}},[(_vm.dialogShow)?_c('statrgy-manager-form',{ref:"outform",on:{"submit":_vm.submit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }